module.exports = __webpack_public_path__ + "static/media/epiglow-4.eb012218.jpg";